import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="bg-mist px-4 py-16 sm:py-24" data-id="element-232" data-mp="27m2adpyzo3bv">
      <SectionHeading eyebrow="Does this sound familiar?" title="Have You Ever Faced Any of These Situations?" lede="If you’ve experienced even one, this clinical library addresses a challenge you already recognize." data-id="element-233" data-mp="27nlpvectmacl" />
      <ol className="mx-auto mt-12 grid max-w-5xl gap-4 md:grid-cols-2 md:gap-5" data-id="element-234" data-mp="2clwzpp348kut">
        {painPoints.map(({
        icon: Icon,
        title,
        text
      }, i) => <li key={title} className="flex gap-4 rounded-2xl bg-white p-5 shadow-[0_1px_0_rgba(10,26,63,0.06)] sm:p-6" data-id="element-235" data-mp="2qkdfe5iyhlp3" data-mpi={i}>
            <div className="flex shrink-0 flex-col items-center" data-id="element-236" data-mp="2mhqktwuwhmo7">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-navy text-electric" data-id="element-237" data-mp="w7nkplkrk8gn">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-238" data-mp="s7d4lg39c1o2" />
              </span>
              <span className="mt-2 font-display text-sm font-black text-navy/30" data-id="element-239" data-mp="1n94mhzip6azk">{i + 1}</span>
            </div>
            <div data-id="element-240" data-mp="1s767wr3lime7">
              <h3 className="font-display text-lg font-extrabold leading-snug text-navy" data-id="element-241" data-mp="1s4k14toj4ax1">{title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-navy/70" data-id="element-242" data-mp="1x46ed34cxr5u">{text}</p>
            </div>
          </li>)}
      </ol>
      <SectionCTA tone="light" label="I’m ready to solve these challenges" data-id="element-243" data-mp="26wki21ezx7un" />
    </section>;
}